export default {
    PRODUCT(state, items) {
        state.items = items
    }
}